import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import styled from 'styled-components'
// import SelectDateRange from '../calendar/SelectDateRange'
// import SelectDate from '../calendar/SelectDate'
import SingleDates from '../calendar/SingleDates'
import RangeDates from '../calendar/RangeDates'
import { Selector } from '../../components'
import SelectRange from '../calendar/SelectRange'
import colors from '../../styles/colors'

export default function CalendarModal({
  title,
  show,
  handleClose,
  handleSubmit,
  setDaysOff,
  range,
  setRange,
  selectedDates,
  setSelectedDates,
  rangeDates,
  setRangeDates,
  daysOffSetting, // 휴무일
  datesToDisplay,
  setDatesToDisplay,
  setSingleCalDisplay,
}) {
  // 날짜선택 <-> 기간선택
  const [showSingleDateCal, setShowSingleDateCal] = useState(true)

  const handleTabs = (flag) => {
    if (flag == 0) {
      setShowSingleDateCal(true)
      setSingleCalDisplay(true)
      setRangeDates([])
    }
    if (flag == 1) {
      setShowSingleDateCal(false)
      setSingleCalDisplay(false)
    }
  }
  const disableTabs = () => {}

  return daysOffSetting ? (
    // 휴무일
    <>
      <ModalContainer show={show} onHide={handleClose} size="lg">
        <Modal.Header className="px-4 border-0" closeButton>
          <ModalTitle className="ms-auto">{title}</ModalTitle>
        </Modal.Header>
        <TabsWrapper>
          <Selector
            leftText={'날짜선택'}
            rightText={'기간선택'}
            selectedIdx={showSingleDateCal == true ? 0 : 1}
            handleTab={handleTabs}
          />
        </TabsWrapper>
        {showSingleDateCal ? (
          <Modal.Body className="text-center ">
            <SingleDates
              range={range}
              rangeDates={rangeDates}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              datesToDisplay={datesToDisplay}
              setDatesToDisplay={setDatesToDisplay}
            />
          </Modal.Body>
        ) : (
          <MultiCalModalBody>
            <RangeDates
              range={range}
              setRange={setRange}
              setDaysOff={setDaysOff}
              rangeDates={rangeDates}
              setRangeDates={setRangeDates}
            />
          </MultiCalModalBody>
        )}

        <ModalFooterWrapper>
          <ModalFooter />
          <SubmitButton onClick={() => handleSubmit()}>
            <SubmitButtonTxt>적용</SubmitButtonTxt>
          </SubmitButton>
        </ModalFooterWrapper>
      </ModalContainer>
    </>
  ) : (
    // 휴무일 제외 나머지
    <>
      <ModalContainer show={show} onHide={handleClose} size="lg">
        <Modal.Header className="px-4 border-0" closeButton>
          <ModalTitle className="ms-auto">{title}</ModalTitle>
        </Modal.Header>

        <TabsWrapper>
          <DisabledSelector>
            <Selector
              leftText={'날짜선택'}
              rightText={'기간선택'}
              selectedIdx={1}
              handleTab={disableTabs}
            />
          </DisabledSelector>
        </TabsWrapper>
        <MultiCalModalBody>
          {/* <MobileCalWrapper> */}
          <SelectRange
            range={range}
            setRange={setRange}
            setDaysOff={setDaysOff}
            rangeDates={rangeDates}
            setRangeDates={setRangeDates}
          />
          {/* </MobileCalWrapper> */}
        </MultiCalModalBody>
        <ModalFooterWrapper>
          <ModalFooter />
          <SubmitButton onClick={() => handleSubmit()}>
            <SubmitButtonTxt>적용</SubmitButtonTxt>
          </SubmitButton>
        </ModalFooterWrapper>
      </ModalContainer>
    </>
  )
}

const ModalContainer = styled(Modal)`
  .modal-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-content {
    width: 619px;
    height: auto;
    @media ${(props) => props.theme.mobile} {
      width: 360px;
      height: auto;
    }
  }
  .btn-close {
    box-shadow: none;
  }
`
const DisabledSelector = styled.div`
  pointer-events: none;
`

const MultiCalModalBody = styled(Modal.Body)`
  @media ${(props) => props.theme.mobile} {
    height: 700px;
  }
`
const TabsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`

const ModalTitle = styled(Modal.Title)`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.BK};
`
const ModalFooterWrapper = styled(Modal.Footer)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: none;
  padding-top: 0;
`
const ModalFooter = styled.div`
  width: 632px;
  height: 1px;
  border: solid 1px ${colors.W4};
  background-color: ${colors.G3};
`
const SubmitButton = styled.button`
  width: 320px;
  height: 50px;
  border-radius: 8px;
  background-color: ${colors.mainG};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
`
const SubmitButtonTxt = styled.span`
  font-family: NotoSansKR;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.W1};
`
